import BusinessLogoUpload from './BusinessLogoUpload';

export default BusinessLogoUpload;
